import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import DProductDetails from 'src/Components/Customer/ProductsAndServicesComponents/DProductDetails';
import DPackageDetails from 'src/Components/Customer/ProductsAndServicesComponents/DPackageDetails';
import ProductReview from 'src/Components/Customer/ProductsAndServicesComponents/ProductReview'

const DiagnosticProductDetails: React.FC = () => {
    const { id = "", type = "" } = useParams();
    const [prodName, setProdName] = useState<string>("");

    return (
        <>
            <div className="w-full p-4">
                <div className="view-area-width box-design p-4 flex flex-col gap-4">
                    {/* <span className="font-Poppins-Regular pt-4 block text-[#707070] font-size-16px">
                        <Link className="text-[#299E96]" to={type === "test" ? "/diagnostic-products" : "/diagnostic-packages"}>Diagnostics </Link>
                        {'>'}
                        {prodName}
                    </span> */}
                    {type === "test" ?
                        <DProductDetails
                            id={id}
                            setName={(val: string) => setProdName(val)}
                        />
                        :
                        <DPackageDetails
                            id={id}
                            setName={(val: string) => setProdName(val)}
                        />
                    }
                    
                    <ProductReview productId={id || ""} />

                </div>
            </div>
        </>
    );
};

export default DiagnosticProductDetails;